import { ColumnFilterItem } from "antd/lib/table/interface";

/**
 * Build a deduped, sorted list of column filter items from a string or string[] field.
 * Empty values are labelled "None". Mirrors the original getList*Filters helpers.
 */
export const createColumnFilters = (
  data: Array<Record<string, unknown>>,
  field: string,
): ColumnFilterItem[] => {
  let result: ColumnFilterItem[] = [];
  data.forEach((item) => {
    const fieldValue = item[field];
    const values: unknown[] = Array.isArray(fieldValue)
      ? fieldValue
      : [fieldValue];
    values.forEach((value) => {
      if (typeof value !== "string") {
        return;
      }
      const filterItem: ColumnFilterItem = {
        text: value === "" ? "None" : value,
        value,
      };
      if (result.filter((it) => it.text === filterItem.text).length === 0) {
        result.push(filterItem);
      }
    });
  });
  result = result.sort((a, b) =>
    a.value < b.value ? -1 : a.value > b.value ? 1 : 0,
  );
  return result;
};

export const STATUS_FILTERS: ColumnFilterItem[] = [
  { text: "Active", value: true },
  { text: "Inactive", value: false },
];
